import { Tooltip, ActionIcon } from "@mantine/core";
import { IconWifi, IconWifiOff } from "@tabler/icons-react";
import { useWSStore } from "@/stores/ws";

export function ConnectionStatus() {
  const connected = useWSStore((s) => s.connected);
  const reconnecting = useWSStore((s) => s.reconnecting);
  const manualReconnect = useWSStore((s) => s.manualReconnect);

  let color: string;
  let label: string;
  let Icon: typeof IconWifi;

  if (connected) {
    color = "green";
    label = "Connected";
    Icon = IconWifi;
  } else if (reconnecting) {
    color = "yellow";
    label = "Reconnecting... — click to retry now";
    Icon = IconWifiOff;
  } else {
    color = "red";
    label = "Disconnected — click to reconnect";
    Icon = IconWifiOff;
  }

  return (
    <Tooltip label={label} withArrow position="bottom">
      <ActionIcon
        variant="subtle"
        color={color}
        aria-label={label}
        onClick={!connected ? manualReconnect : undefined}
        style={!connected ? { cursor: "pointer" } : undefined}
      >
        <Icon size={20} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
